import { render, staticRenderFns } from "./WelcomingStep.vue?vue&type=template&id=716f1992&"
import script from "./WelcomingStep.vue?vue&type=script&lang=js&"
export * from "./WelcomingStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('716f1992')) {
      api.createRecord('716f1992', component.options)
    } else {
      api.reload('716f1992', component.options)
    }
    module.hot.accept("./WelcomingStep.vue?vue&type=template&id=716f1992&", function () {
      api.rerender('716f1992', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppSurvey/WelcomingStep.vue"
export default component.exports